import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const STYLESHEET_CONTEXT_SYMBOL = Symbol();
const useStylesheet = () => useImmutableContext(STYLESHEET_CONTEXT_SYMBOL);
const useStylesheetProvider = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return useImmutableContextProvider(STYLESHEET_CONTEXT_SYMBOL, ...args);
};
export { useStylesheet, useStylesheetProvider };